import React from 'react';
import { useLocalization } from '../engine/localization/context';
import { SUPPORTED_LOCALES } from '../engine/localization/types';
import { Globe } from 'lucide-react';

export const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale, supportedLocales } = useLocalization();

  if (supportedLocales.length <= 1) return null;

  return (
    <div className="inline-flex items-center gap-1.5 p-1 rounded-full bg-slate-900/60 backdrop-blur-md border border-white/10 shadow-sm text-xs font-medium">
      <div className="flex items-center gap-1 px-2 py-0.5 text-slate-400">
        <Globe className="w-3.5 h-3.5 text-sky-400" />
      </div>
      {supportedLocales.map((code) => {
        const meta = SUPPORTED_LOCALES[code];
        const isActive = locale === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLocale(code)}
            aria-pressed={isActive}
            className={`px-3 py-1 rounded-full transition-all duration-200 ${
              isActive
                ? 'bg-sky-500 text-white font-semibold shadow-sm'
                : 'text-slate-300 hover:text-white hover:bg-white/5'
            }`}
          >
            {meta?.nativeName || code.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
};

